<div class="modal-header">
  <h4 class="modal-title pull-left">Login to Your Account</h4>
  <button type="button" class="close pull-right circle-icon" aria-label="Close" role="button" (click)="hideAndReset()">
    <img src="../assets/images/cross.svg" />
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="loginForm" autocomplete="on">
    <div class="form-group mb-4 no-float-fields">
      <label class="form-label">Email *</label>
      <mat-form-field appearance="outline">
        <input matInput type="text" formControlName="email" placeholder="Enter email" autocomplete="email"
          [value]="email" />
      </mat-form-field>
      <p class="pass-note m-0 text-danger" *ngIf="
          loginForm.get('email').hasError('email') &&
          (loginForm.get('email').dirty || loginForm.get('email').touched)
        ">
        Invalid email
      </p>
    </div>

    <div class="form-group mb-4 no-float-fields">
      <label class="form-label">Password *</label>
      <span class="for-pass-show">
        <mat-form-field appearance="outline">
          <input matInput [type]="hidelp ? 'password' : 'text'" formControlName="password" [value]="password"
            autocomplete="current-password" />
          <mat-icon class="cursor-pointer" matSuffix role="button" (click)="hidelp = !hidelp">
            {{ hidelp ? "visibility_off" : "visibility" }}</mat-icon>
        </mat-form-field>
        <p class="pass-note m-0 text-danger" *ngIf="
            loginForm.get('password').hasError('requried') &&
            (loginForm.get('password').dirty ||
              loginForm.get('password').touched)
          ">
          Invalid email
        </p>
      </span>
    </div>
    <p class="pass-note m-0 text-danger" *ngIf="error != ''">{{ error }}</p>

    <div class="remeber-wrap">
      <div class="custom-checks-square check-grey">
        <input type="checkbox" id="remember" formControlName="rememberme" />
        <label for="remember" class="m-0">Remember Me</label>
      </div>
      <a class="forgot" href="javascript:void(0)" role="button"
        (click)="modalRef.hide(); openModalFile('forget-password')">Forgot Password?</a>
    </div>
    <button type="button" type="submit" class="btn btn-colored btn-login" role="button" (click)="login()"
      [disabled]="loading || !loginForm.valid">
      <span *ngIf="loading" class="spinner-border spinner-border-sm mr-1"></span>
      Login
    </button>

    <div class="no-account mb-3">
      <a class="forgot" href="javascript:void(0)" role="button" (click)="
          modalRef.hide(); openModalFile('returning-user-forgot-password')
        ">Returning User? Click Here to create a new password</a>
    </div>

    <div class="no-account">
      Do not have an Account?
      <a href="javascript:void(0);" role="button" (click)="modalRef.hide(); openModalFile('register')">Create
        Account</a>
    </div>
  </form>
</div>
